import { createApi } from "@reduxjs/toolkit/query/react";
import { useDispatch } from "react-redux";

import { abfSerializeQueryArgs, marketsBaseQuery } from "./util";
import {
    ApiUserLoansResponse,
    ApiUserStrategiesResponse,
    ApiUserVaultsResponse,
    UserLoansFilter,
    UserStrategiesFilter,
    UserVaultsFilter
} from "../types";
import { ROUTE_USER_LOANS, ROUTE_USER_STRATEGIES, ROUTE_USER_VAULTS } from "../constants";

const USER_STRATEGIES_TAG = "UserStrategies";
const USER_LOANS_TAG = "UserLoans";
const USER_VAULTS_TAG = "UserVaults";

export const userApi = createApi({
    reducerPath: "userApi",
    tagTypes: [USER_STRATEGIES_TAG, USER_LOANS_TAG, USER_VAULTS_TAG],
    baseQuery: marketsBaseQuery,
    serializeQueryArgs: abfSerializeQueryArgs,

    endpoints: (builder) => ({
        userStrategies: builder.query<ApiUserStrategiesResponse, UserStrategiesFilter>({
            providesTags: [USER_STRATEGIES_TAG],
            query(filter) {
                return {
                    url: ROUTE_USER_STRATEGIES,
                    method: "POST",
                    body: filter
                };
            }
        }),
        userLoansGroups: builder.query<ApiUserLoansResponse, UserLoansFilter>({
            providesTags: [USER_LOANS_TAG],
            query(filter) {
                return {
                    url: ROUTE_USER_LOANS,
                    method: "POST",
                    body: filter
                };
            }
        }),
        userVaultsGroups: builder.query<ApiUserVaultsResponse, UserVaultsFilter>({
            providesTags: [USER_VAULTS_TAG],
            query(filter) {
                return {
                    url: ROUTE_USER_VAULTS,
                    method: "POST",
                    body: filter
                };
            }
        })
    })
});

export const { useUserStrategiesQuery, useUserLoansGroupsQuery, useUserVaultsGroupsQuery } = userApi;

export const useUserApi = () => {
    const dispatch = useDispatch();

    return {
        resetUserApi: () =>
            dispatch(userApi.util.invalidateTags([USER_STRATEGIES_TAG, USER_LOANS_TAG, USER_VAULTS_TAG]))
    };
};
